import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateInvoiceCarrierActions as Actions,
  UpdateInvoiceCarrierRequestAction as RequestAction,
} from 'store/ducks/pendingRelease';

export function* updateInvoiceCarrierRequest(action: any) {
  const { payload, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.post, `invoices/carrier`, payload);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
